import { Button, CardBackground, Typography } from "@hellocarbo/lasagne";
import { Trans, useTranslation } from "react-i18next";

import lcaImage from "@/assets/fr/lca.png";
import AdditionalModules from "@/components/LCA/AdditionalModules";
import PageWrapper from "@/components/ui/PageWrapper";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";
import useSegmentEvent from "@/hooks/useSegmentEvent";

function LCA() {
  const { t } = useTranslation(["common", "lca"]);
  const outboundQueryParams = useOutboundQueryParams("acv");
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <PageWrapper>
      <div className="mx-xl my-lg">
        <Typography as="h1" step="3" weight="bold" className="mb-sm">
          {t("lca:productAndServiceLCA")}
        </Typography>
        <CardBackground>
          <Typography as="h2" step="2" weight="bold">
            {t("lca:LCA:title")}
          </Typography>
          <Typography className="mb-md">{t("lca:LCA:description")}</Typography>
          <div className="gap-x-2xl gap-y-md mb-md flex flex-col lg:grid lg:grid-cols-2">
            <div className="gap-y-lg flex flex-col">
              <div>
                <Typography as="h2" step="1" weight="bold" className="mb-xs">
                  {t("lca:LCA:whyConductAnLCA.title")}
                </Typography>
                <ul className="list-inside list-disc">
                  <Typography as="li">
                    <Trans
                      t={t}
                      i18nKey="lca:LCA:whyConductAnLCA.listItem1"
                      components={{ 1: <span className="font-bold" /> }}
                    />
                  </Typography>
                  <Typography as="li">
                    <Trans
                      t={t}
                      i18nKey="lca:LCA:whyConductAnLCA.listItem2"
                      components={{ 1: <span className="font-bold" /> }}
                    />
                  </Typography>
                  <Typography as="li">
                    <Trans
                      t={t}
                      i18nKey="lca:LCA:whyConductAnLCA.listItem3"
                      components={{ 1: <span className="font-bold" /> }}
                    />
                  </Typography>
                  <Typography as="li">
                    <Trans
                      t={t}
                      i18nKey="lca:LCA:whyConductAnLCA.listItem4"
                      components={{ 1: <span className="font-bold" /> }}
                    />
                  </Typography>
                </ul>
              </div>
              <div>
                <Typography as="h2" step="1" weight="bold" className="mb-xs">
                  {t("lca:LCA:whatResultsDoYouGet.title")}
                </Typography>
                <ul className="list-inside list-disc">
                  <Typography as="li">
                    <Trans
                      t={t}
                      i18nKey="lca:LCA:whatResultsDoYouGet.listItem1"
                      components={{ 1: <span className="font-bold" /> }}
                    />
                  </Typography>
                  <Typography as="li">
                    <Trans
                      t={t}
                      i18nKey="lca:LCA:whatResultsDoYouGet.listItem2"
                      components={{ 1: <span className="font-bold" /> }}
                    />
                  </Typography>
                  <Typography as="li">
                    <Trans
                      t={t}
                      i18nKey="lca:LCA:whatResultsDoYouGet.listItem3"
                      components={{ 1: <span className="font-bold" /> }}
                    />
                  </Typography>
                  <Typography as="li">
                    <Trans
                      t={t}
                      i18nKey="lca:LCA:whatResultsDoYouGet.listItem4"
                      components={{ 1: <span className="font-bold" /> }}
                    />
                  </Typography>
                </ul>
              </div>
            </div>
            <img
              src={lcaImage}
              alt={t("lca:imageAltText")}
              className="max-h-[400px] self-center justify-self-center"
            />
          </div>
          <div className="gap-x-sm flex justify-center">
            <Button
              as="a"
              href="https://lcai.hellocarbo.com/"
              shouldOpenNewTab
              onClick={() => sendSegmentEvent("option_demo_acv")}
              intent="primary"
            >
              {t("common:freeTrialLCAI")}
            </Button>
            <Button
              as="a"
              href={`https://try.hellocarbo.com/meetings/julien-janson?${outboundQueryParams}`}
              shouldOpenNewTab
              onClick={() => sendSegmentEvent("option_demo_acv")}
              intent="secondary"
            >
              {t("common:coachCall")}
            </Button>
          </div>
        </CardBackground>
        <AdditionalModules />
      </div>
    </PageWrapper>
  );
}

export default LCA;
